import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CheckAccountPermissionsResponse } from '../../Models/Domains/Customer/CheckAccountPermissionsResponse';

declare var IS_RUNNING_IN_APP_POOL;

export class CheckAdviserBridgeAccountPermissionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number): Promise<CheckAccountPermissionsResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CheckAdviserBridgeAccountPermissions/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId }

    return AjaxWrapper.get<CheckAccountPermissionsResponse, any>(url, data);
  }
}

